import React, { useEffect, useState } from 'react'
import { fetchCustomerProfit, fetchOrderProfit, fetchProductProfit } from '../api/dashboardApi';
import { formatDate, formatNumber, writeProductName } from '../utils/functions';
import Input from '../components/Input';
import CustomerProfitModal from '../components/dashboard/CustomerProfitModal';


const HomePage = ({ title }) => {

    const [orders, setOrders] = useState([])
    const [orderFirstDate, setOrderFirstDate] = useState("")
    const [orderLastDate, setOrderLastDate] = useState("")
    const [search, setSearch] = useState("")
    const [customerProfits, setCustomerProfits] = useState([])
    const [isOpenCustomerOrdersModal, setIsOpenCustomerOrdersModal] = useState(false)
    const [selectedCustomerProfit, setSelectedCustomerProfit] = useState(null)

    const [productProfit, setProductProfit] = useState([])

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const [tab, setTab] = useState('SİPARİŞ') //SATIN ALIM, SİPARİŞ

    const loadOrderProfit = async (params) => {
        const { data } = await fetchOrderProfit(params)
        setOrders(data)
    }

    const loadCustomerProfit = async (params) => {
        const { data } = await fetchCustomerProfit(params)
        setCustomerProfits(data)
    }

    const loadProductProfit = async (params) => {
        const { data } = await fetchProductProfit(params)
        setProductProfit(data)
    }

    useEffect(() => {
        loadOrderProfit({ orderFirstDate, orderLastDate })
        loadCustomerProfit({ orderFirstDate, orderLastDate })
        loadProductProfit({ orderFirstDate, orderLastDate })
    }, [orderFirstDate, orderLastDate])


    return (
        <div>
            <div className='mb-1 border-b border-zinc-300 gap-x-5 flex items-center'>
                <label className='text-2xl'>
                    DASHBOARD
                </label>
            </div>
            <div className='grid grid-cols-3 gap-x-2 py-2 sticky top-0 bg-zinc-50'>
                {['SİPARİŞ', 'MÜŞTERİ', "ÜRÜN"].map((t, i) => (
                    <label
                        key={i}
                        className={`${tab === t ? 'bg-purple-700 text-white' : ''} block px-2 py-1 text-xl text-center hover:bg-purple-700 hover:text-white duration-150 cursor-pointer border`}
                        onClick={() => setTab(t)}
                    >
                        {t}
                    </label>
                ))}
            </div>
            <div className='shadow-lg border rounded-md p-2'>
                <label className='block'>Filtreler</label>
                <div className='grid grid-cols-4 gap-x-3'>
                    <div className='col-span-1'>
                        <Input type="text" label="Arama" value={search} onChange={e => setSearch(e.target.value)} />
                    </div>
                    <div className='col-span-1'>
                        <Input type="date" label="İlk Tarih" value={orderFirstDate} onChange={e => setOrderFirstDate(e.target.value)} />
                    </div>
                    <div className='col-span-1'>
                        <Input type="date" label="Son Tarih" value={orderLastDate} onChange={e => setOrderLastDate(e.target.value)} />
                    </div>
                    <div>
                        {
                            tab === "SİPARİŞ" &&
                            <div>
                                <label className='block mb-3'>Toplam Kar</label>
                                {
                                    formatNumber(
                                        orders
                                            .sort((a, b) => new Date(b.order.orderDate) - new Date(a.order.orderDate))
                                            .filter(order => order.order.customerName.toLowerCase().includes(search.toLowerCase()))
                                            .reduce((a, c) => a + c.profit, 0))
                                } USD
                            </div>
                        }
                        {
                            tab === "MÜŞTERİ" &&
                            <div>
                                <label className='block mb-3'>Toplam Kar</label>
                                {
                                    formatNumber(
                                        customerProfits
                                            .sort((a, b) => b.totalProfit - a.totalProfit)
                                            .filter(order => order.customer.name.toLowerCase().includes(search.toLowerCase()))
                                            .reduce((a, c) => a + c.totalProfit, 0)
                                    )
                                } USD
                            </div>
                        }
                        {
                            tab === "ÜRÜN" &&
                            <div>
                                <label className='block mb-3'>Toplam Kar</label>
                                {
                                    formatNumber(
                                        productProfit
                                            .sort((a, b) => b.totalRevenue - a.totalRevenue)
                                            .filter(order => order.product.collectionName.toLowerCase().includes(search.toLowerCase()))
                                            .reduce((a, c) => a + c.totalRevenue, 0)
                                    )
                                } USD
                            </div>
                        }
                    </div>
                </div>
            </div>
            {
                tab === "SİPARİŞ" &&
                <div>
                    <table className='w-full text-left text-zinc-900 mb-10 text-sm'>
                        <thead className='text-xs uppercase tracking-wide sticky top-12 bg-zinc-50'>
                            <tr>
                                <th className='p-2 w-1/12'>Id</th>
                                <th className='p-2 w-3/12'>
                                    Müşteri
                                </th>
                                <th className='p-2 w-2/12'>Tarih</th>
                                <th className='p-2 w-2/12'>Fatura No</th>
                                <th className='p-2 w-1/12'>Maliyet</th>
                                <th className='p-2 w-1/12'>Fiyat</th>
                                <th className='p-2 w-1/12'>Kar</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                orders
                                    .sort((a, b) => new Date(b.order.orderDate) - new Date(a.order.orderDate))
                                    .filter(order => order.order.customerName.toLowerCase().includes(search.toLowerCase()))
                                    .map((r, i) => (
                                        <tr key={i}>
                                            <td className='p-2'># {r.order.id} </td>
                                            <td className='p-2'>{r.order.customerName} </td>
                                            <td className='p-2'>{formatDate(r.order.orderDate)} </td>
                                            <td className='p-2'>{r.order.invoiceNumber} </td>
                                            <td className='p-2'>{formatNumber(r.cost)} USD</td>
                                            <td className='p-2'>{formatNumber(r.order.cost)} {r.order.currency}</td>
                                            <td className='p-2 text-center'>
                                                {formatNumber(r.profit)} USD
                                            </td>
                                        </tr>
                                    ))
                            }
                        </tbody>
                    </table>
                </div>
            }
            {
                tab === "MÜŞTERİ" &&
                <div>
                    <table className='w-full text-left text-zinc-900 mb-10 text-sm'>
                        <thead className='text-xs uppercase tracking-wide sticky top-12 bg-zinc-50'>
                            <tr>
                                <th className='p-2 w-1/12'>Id</th>
                                <th className='p-2 w-3/12'>
                                    Müşteri
                                </th>
                                <th className='p-2 w-2/12'>Maliyet</th>
                                <th className='p-2 w-2/12'>Gelir</th>
                                <th className='p-2 w-1/12'>Kar</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                customerProfits
                                    .sort((a, b) => b.totalProfit - a.totalProfit)
                                    .filter(order => order.customer.name.toLowerCase().includes(search.toLowerCase()))
                                    .map((r, i) => (
                                        (r.totalCost || r.totalSold || r.totalProfit) ?
                                            <tr className='hover:bg-violet-200 cursor-pointer duration-150' key={i} onClick={() => {
                                                setSelectedCustomerProfit(r)
                                                setIsOpenCustomerOrdersModal(true)
                                            }}>
                                                <td className='p-2'># {r.customer.id} </td>
                                                <td className='p-2'>{r.customer.name} </td>
                                                <td className='p-2'>{formatNumber(r.totalCost)} USD</td>
                                                <td className='p-2'>{formatNumber(r.totalSold)} {r.customer.currency} </td>
                                                <td className='p-2'>{formatNumber(r.totalProfit)} USD</td>
                                            </tr>
                                            : null
                                    ))
                            }
                        </tbody>
                    </table>
                </div>
            }
            {
                tab === "ÜRÜN" &&
                <div>
                    <table className='w-full text-left text-zinc-900 mb-10 text-sm'>
                        <thead className='text-xs uppercase tracking-wide sticky top-12 bg-zinc-50'>
                            <tr>
                                <th className='p-2 w-1/12'>Id</th>
                                <th className='p-2 w-3/12'>
                                    Ürün Adı
                                </th>
                                <th className='p-2 w-2/12'>Toplam Satış</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                productProfit
                                    .sort((a, b) => b.totalRevenue - a.totalRevenue)
                                    .filter(order => order.product.collectionName.toLowerCase().includes(search.toLowerCase()))
                                    .map((r, i) => (
                                        (r.totalRevenue) ?
                                            <tr className='' key={i} onClick={() => {

                                            }}>
                                                <td className='p-2'># {r.product.id} </td>
                                                <td className='p-2'>{writeProductName(r.product)} </td>
                                                <td className='p-2'>{formatNumber(r.totalRevenue)} USD</td>
                                                {/* <td className='p-2'>{r.customer.name} </td>
                                                <td className='p-2'>{formatNumber(r.totalCost)} USD</td>
                                                <td className='p-2'>{formatNumber(r.totalSold)} {r.customer.currency} </td>
                                                <td className='p-2'>{formatNumber(r.totalProfit)} USD</td> */}
                                            </tr>
                                            : null
                                    ))
                            }
                        </tbody>
                    </table>
                </div>
            }
            <CustomerProfitModal
                isOpen={isOpenCustomerOrdersModal}
                closeModal={() => setIsOpenCustomerOrdersModal(false)}
                customerProfit={selectedCustomerProfit}
            />
        </div>
    )
}

export default HomePage